import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDipCoatingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			id: "white",
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "m12.93,5.79l-.98.02-5.12,8.94,1.14,1.94h.18l.17.29,1.07,1.85.03.05-.12.06.1.16,2.22-1.44h1.67l1.09.53,1.15.81h0s.1-.18.1-.18l1.07-1.86.12-.2h.12s1.18-2.06,1.18-2.06l-5.18-8.94Zm-3.06,12.89l-.05-.1-.92-1.59-.17-.29h.36l.13.23.84,1.46.08.15-.28.14Z"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "grey",
			children: [/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "m18.38,14.61l-5.18-8.96s-.02-.03-.03-.04v-.02s-.03-.02-.04-.02h0v-.02h-.06s-.03-.02-.05-.02h-.94s-.04.01-.07.01c0,0-.03,0-.05.02-.01.01-.02.01-.03.02l-.02.02s-.02.03-.03.05l-5.21,9.02s-.03.07-.03.12c0,.04.01.08.03.11l1.08,1.88h.54l-1.02-1.76h.4l1.02,1.76h.53l-1.15-1.99,4.94-8.56,4.5,7.79.41.71-1.22,2.12.45.06h.05l1.19-2.07c.04-.07.04-.15,0-.23Zm-10.67.02h-.58l.26-.45.08-.14,4.69-8.12h.57l-5.02,8.71Z"
			}), /* @__PURE__ */ _jsxs("g", {
				className: "cls-3",
				children: [
					/* @__PURE__ */ _jsx("polygon", {
						className: "icon-outline",
						points: "7.65 16.63 9.11 19.14 9.52 18.94 8.19 16.63 7.65 16.63"
					}),
					/* @__PURE__ */ _jsx("polygon", {
						className: "icon-outline",
						points: "8.59 16.63 9.84 18.78 10.25 18.58 9.13 16.63 8.59 16.63"
					}),
					/* @__PURE__ */ _jsx("polygon", {
						className: "icon-outline",
						points: "17.15 16.76 16.77 16.71 15.55 18.82 15.4 19.08 15.79 19.21 15.86 19.22 17.13 17 17.28 16.76 17.15 16.76"
					})
				]
			})]
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "color",
			children: /* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m7.25,13.63l-.29.52c-.07-.06-.15-.12-.21-.18-.48-.4-1.08-.84-2.1-.84h-.48c-.17,0-.3-.13-.3-.29s.13-.29.3-.29h.48c1.32,0,2.07.64,2.47.98.04.03.09.07.13.1Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m21.13,12.84c0,.16-.13.29-.3.29h-.49c-1.03.03-1.56.44-2.08.84l-.03.02s-.09.07-.14.12l-.29-.51s.06-.05.08-.07l.02-.02c.57-.44,1.2-.93,2.44-.96h.49c.17,0,.3.13.3.29Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m20.83,17.31h-.5c-1.23.03-1.87.52-2.43.95l-.03.02c-.46.38-.78.62-1.45.62-.18,0-.33-.02-.48-.05-.1-.02-.19-.05-.28-.09-.25-.11-.47-.29-.69-.47-.4-.34-1.16-.97-2.47-.97-1.21,0-1.84.49-2.4.92l-.12.09c-.08.06-.16.12-.23.18-.16.12-.29.2-.41.25-.09.04-.18.07-.28.1-.14.03-.3.05-.48.05-.67,0-1-.23-1.46-.62-.4-.34-1.16-.97-2.47-.97h-.49c-.16,0-.29.13-.29.29s.13.29.29.29h.49c1.01,0,1.61.43,2.09.84.52.44.96.76,1.83.76.27,0,.51-.03.72-.09h.02c.11-.04.21-.08.31-.13.14-.07.27-.15.44-.27.08-.06.17-.12.25-.19l-.06-.08.09.06.12-.09c.51-.39,1.03-.8,2.04-.8s1.61.43,2.09.84c.23.2.49.4.79.54.1.05.21.09.31.12.22.06.46.09.73.09.87,0,1.32-.33,1.84-.76.51-.4,1.05-.81,2.08-.83h.49c.16,0,.29-.13.29-.29s-.13-.29-.29-.29Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-highlight",
					d: "m20.83,14.93h-.5c-1.23.03-1.87.52-2.43.95l-.03.02c-.18.15-.32.26-.46.35h0l-.06.03c-.14.08-.29.14-.44.18-.15.04-.31.05-.49.05-.67,0-1-.23-1.45-.62-.4-.34-1.15-.98-2.47-.98-1.21,0-1.84.49-2.4.92l-.12.09c-.37.28-.61.47-.98.54-.1.02-.21.03-.33.03-.03,0-.06,0-.09,0-.18,0-.34-.02-.49-.05-.15-.03-.3-.09-.42-.16l-.02-.02c-.17-.1-.33-.22-.53-.39-.4-.34-1.15-.98-2.47-.98h-.49c-.16,0-.29.13-.29.29s.13.29.29.29h.49c1.01,0,1.61.43,2.09.84.35.29.67.55,1.14.67h.01c.13.04.26.06.4.07.19.02.42.02.59,0,.12-.01.24-.03.34-.06.19-.05.37-.13.56-.24.19-.11.37-.25.54-.39l.12-.09c.51-.39,1.03-.8,2.04-.8s1.61.43,2.09.84c.2.17.42.35.66.48l.07.03c.32.17.67.24,1.1.24.1,0,.19,0,.28-.01.14-.01.28-.04.4-.07h.01c.46-.13.78-.38,1.14-.68.51-.4,1.05-.81,2.08-.83h.49c.16,0,.29-.13.29-.29s-.13-.29-.29-.29Z"
				})
			] })
		})
	]
});
export default SvgDipCoatingSm;
